(() => {
  let hasStickyValue = false;
  window.addEventListener('scroll', () => {
    const stickyHeader = document.querySelector('.shopify-section-header-sticky');
    if(stickyHeader && !hasStickyValue) {
      document.documentElement.style.setProperty('--sticky-header-height', stickyHeader.getBoundingClientRect().height + 'px');
      hasStickyValue = true;
    }
  })
})();